import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { AppCopy } from '@models/cms/app.model';
import { ModalService } from '@services/modal/modal.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { VerifiedByNorseModalComponent } from '../verified-by-norse-modal/verified-by-norse-modal.component';
import {
  SafeHtmlPipe,
  SanitizerValueType,
} from '@pipes/safe-html/safe-html.pipe';
import { GrowthBookService } from '@services/growthbook/growthbook.service';
import { GrowthBookFeatureKeys } from '@models/growthbook.models';
import { VerifiedByNorseVariantCComponent } from './verified-by-norse-variant-c/verified-by-norse-variant-c.component';

@Component({
  selector: 'app-verified-by-norse',
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule,
    SafeHtmlPipe,
    VerifiedByNorseVariantCComponent,
  ],
  templateUrl: './verified-by-norse.component.html',
  styleUrl: './verified-by-norse.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifiedByNorseComponent {
  @Input() appCopy: AppCopy;

  readonly gbf = GrowthBookFeatureKeys;
  readonly SanitizerValueType = SanitizerValueType;

  private gbs = inject(GrowthBookService);

  get isVariantC(): boolean {
    return (
      this.gbs.growthBook.isOn(this.gbf.FEAT_US344_VERIFIED_BY_NORSE) &&
      this.gbs.growthBook.getFeatureValue(
        this.gbf.FEAT_US344_VERIFIED_BY_NORSE,
        '',
      ) === 'c'
    );
  }

  constructor(private modalService: ModalService) {}

  onInfoClick(): void {
    this.modalService.show(VerifiedByNorseModalComponent, {
      class: 'modal-desktop-600',
      initialState: {
        appCopy: this.appCopy,
      },
    });
  }
}
